import * as React from 'react';

import type { PageProps } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';

import { CtaBlock } from 'stile-shared/src/components/2020/blocks/CtaBlock';
import { HeroBlock } from 'stile-shared/src/components/2020/blocks/HeroBlock';
import { TextBlock } from 'stile-shared/src/components/2020/blocks/TextBlock';
import { ButtonLink } from 'stile-shared/src/components/2020/common/ButtonLink';
import { P } from 'stile-shared/src/components/2020/common/Primitives';
import { VideoModalLauncher } from 'stile-shared/src/components/2020/common/VideoModalLauncher';

import { getPageData } from 'utils/getPageData';

import { PageLayout } from 'templates/2020/PageLayout';

import { NextPageBlock } from 'components/blocks/NextPageBlock';

export { Head } from 'templates/2020/Head';

function ScienceWeekPage(props: PageProps) {
  const { hero } = getPageData(props.location.pathname);
  const emailSubject = 'Enquiry regarding Stile resources';
  const emailBody = `Hi [First name],

I'm writing to enquire about the possibility of our school investigating the use of Stile, a customisable core curriculum built right here in Australia.

I believe Stile could greatly benefit our students' understanding and enthusiasm for science. I know my child would love it.

Could you please explore the suitability of Stile for our school's science program? I'm happy to assist further if needed. You can view their website at https://www.stileeducation.com/. 

Best regards,

[Your Name]
[Your Contact Information]`;

  return (
    <PageLayout {...props}>
      <HeroBlock
        {...hero}
        image={
          <VideoModalLauncher
            url="https://youtu.be/0gzOumeuY3o"
            text="Hear from two of Stile’s co-founders"
            coverImage={
              <StaticImage
                src="../../../../stile-shared/assets/images/parents/parents_cover.png"
                alt=""
              />
            }
          />
        }
      />

      <TextBlock>
        <P>
          For our young citizens to prosper, we must ensure they leave school scientifically
          literate and confident to tackle tomorrow’s problems. Stile is rethinking STEM education
          in an effort to ensure your child graduates as informed, reflective citizens — citizens
          equipped to create a better future for themselves, and for others.
        </P>

        <P>
          Each science unit within Stile’s curriculum is centred around a real-world phenomenon,
          which provides the perfect opportunity for you to discuss it at home with your child. With
          rich, relevant scientific issues embedded into every lesson, we hope you’ll get a slightly
          more interesting response to “Did you learn anything interesting at school today?” than
          “no”.
        </P>

        <P>
          Want your students to start using Stile? Speak to your principal or P&C committee about
          getting Stile.
        </P>

        <P>
          We’ve put together an email template as a starting point for you to send to your school.
        </P>

        <ButtonLink
          openInNewTab
          url={'mailto:?subject=' + encodeURI(emailSubject) + '&body=' + encodeURI(emailBody)}
        >
          Send email to school
        </ButtonLink>
      </TextBlock>

      <NextPageBlock path="/what-is-stile/whats-included/" />

      <CtaBlock />
    </PageLayout>
  );
}

export default ScienceWeekPage;
